import { render, staticRenderFns } from "./DevicesListTable.vue?vue&type=template&id=0ab635e8&scoped=true"
import script from "./DevicesListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DevicesListTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DevicesListTable.vue?vue&type=style&index=0&id=0ab635e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab635e8",
  null
  
)

export default component.exports